// @flow

import type {Effect} from '../../types'

import {
  call,
  put,
  spawn
} from 'redux-saga/effects'
import {delay} from 'redux-saga'

import {fetchApiIndex} from '../lib/fetchApiIndex'
import {mapActions} from '../actions'
import {googleMapApi} from '../../../google-map'
import {loadCitiesAndDistricts} from './loadCitiesAndDistricts'

export function* initEffect(): Effect {
  yield spawn(loadCitiesAndDistricts)
  try {
    const apiIndex: ApiIndex<MapApi> = yield call(fetchApiIndex)
    const map = yield call(googleMapApi.makeMap) 
    yield put(mapActions.setApiIndex(apiIndex))
    yield put(mapActions.setGoogleMap(map))
    yield put(mapActions.setReady())
  } catch (error) {
    yield call(delay, 500)
    yield call(initEffect)
  }
}
